import { render, staticRenderFns } from "./AnchorList.vue?vue&type=template&id=9f2f711c&scoped=true"
import script from "./AnchorList.vue?vue&type=script&lang=js"
export * from "./AnchorList.vue?vue&type=script&lang=js"
import style0 from "./AnchorList.vue?vue&type=style&index=0&id=9f2f711c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2f711c",
  null
  
)

export default component.exports